<template>
  <router-view />
</template>

<script>
export default {
  name: "app",
  components: {},
  created() {
    this.$store.getters.api.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response.status == 401) {
          this.$store.dispatch("user/logout");
          this.$router.push("/login");
        }

        if (error.response.status == 403) {
          this.$router.push("/");
          this.$notify({
            title: "Acceso denegado",
            type: "warning",
            content:
              "Lo sentimos, no tiene permisos para visualizar esta información",
            duration: 0
          });
        }

        return Promise.reject(error);
      }
    );

    localStorage.getItem("user")
      ? this.$store.commit(
          "user/SET_USER",
          JSON.parse(localStorage.getItem("user"))
        )
      : "";
    !this.$store.state.user.user && this.$store.state.user.isAuthenticated
      ? this.$store.dispatch("user/getAuthUser")
      : "";
    localStorage.getItem("marcador")
      ? this.$store.commit(
          "user/SET_MARCADOR",
          localStorage.getItem("marcador")
        )
      : "";
  }
};
</script>

<style lang="scss" src="./assets/scss/app.scss"></style>
